import {
  Box,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Tooltip,
  useDisclosure,
} from '@frontend/legacy-components';

import { ViewerButton } from './ViewerButton';

export const ViewerPopoverButton = ({
  children,
  title,
  icon,
}: {
  children: React.ReactNode;
  title: string;
  icon: React.ReactNode;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Popover
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      autoFocus
      placement="auto"
      size="sm"
    >
      <PopoverTrigger>
        <ViewerButton isActive={isOpen} aria-label={title} position="relative">
          <Tooltip label={title} placement="bottom">
            <Box
              position="absolute"
              inset={0}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {icon}
            </Box>
          </Tooltip>
        </ViewerButton>
      </PopoverTrigger>
      <PopoverContent>
        <PopoverHeader textTransform="none">{title}</PopoverHeader>
        <PopoverBody>{children}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
ViewerPopoverButton.displayName = 'ViewerPopoverButton';

export default ViewerPopoverButton;
